import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c(VExpansionPanels,{attrs:{"focusable":""}},[_c(VExpansionPanel,{staticClass:"rounded-card"},[_c(VExpansionPanelHeader,[_c('px-reposta-card-cotacao-header',{attrs:{"cotacao":_vm.cotacao}})],1),_c(VExpansionPanelContent,[_c('px-resposta-card-cotacao-detalhes',{attrs:{"cotacao":_vm.cotacao}})],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }